module.exports = __webpack_public_path__ + "img/banner_1_en.b1fd5268.png";